"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "BulkImport___StyledSvg",
  componentId: "sc-115ph4t-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function BulkImport(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2a6.959 6.959 0 00-6.437 4.253A4.958 4.958 0 007 6c-2.757 0-5 2.243-5 5a5.008 5.008 0 004 4.899v-2.084A2.993 2.993 0 014 11c0-1.654 1.346-3 3-3 .57 0 1.13.167 1.618.481a1 1 0 001.516-.614A4.973 4.973 0 0115 4c2.757 0 5 2.243 5 5 0 1.627-.793 3.061-2 3.975v2.34c2.361-1.127 4-3.53 4-6.315 0-3.86-3.14-7-7-7z",
    fill: "currentColor"
  }), _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.707 14.293L12 9.586l-4.707 4.707 1.414 1.414L11 13.414V22h2v-8.586l2.293 2.293 1.414-1.414z",
    fill: "currentColor"
  }));
}

var _default = BulkImport;
exports["default"] = _default;